export default "__VITE_PUBLIC_ASSET__40de63ca__"